export default __webpack_public_path__ + "app/components/widgets/pieChartsW/pieChartsWidget.html";